import {useState} from "react";
import {Control, Controller, FieldErrors, FieldPath, FieldValues} from "react-hook-form";
import {DatePicker} from "@mui/x-date-pickers";
import _ from "lodash";
import {Dayjs} from "dayjs";
import {IconButton, InputAdornment} from "@mui/material";
import CalendarIcon from "@mui/icons-material/CalendarTodayOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface Props<TFieldValues extends FieldValues = FieldValues> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    errors: FieldErrors<TFieldValues>;
    onChange?: (date: Dayjs | null) => void;
}

export const DatePickerInput = <TFieldValues extends FieldValues = FieldValues>(props: Props<TFieldValues>) => {
    const {name, control, errors, onChange} = props;
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Controller
            name={name}
            control={control}
            render={({field: {onChange: onControllerChange, value}}) => {
                const error = !!_.get(errors, name);
                const helperText = _.get(errors, name)?.message as string;
                return (
                    <DatePicker
                        open={isOpen}
                        onOpen={() => setIsOpen(true)}
                        onClose={() => setIsOpen(false)}
                        value={value ? value : null}
                        onChange={(newValue) => {
                            onControllerChange(newValue ? newValue : null);
                            if (onChange) {
                                onChange(newValue ? newValue : null);
                            }
                        }}
                        slotProps={{
                            textField: {
                                variant: "filled",
                                fullWidth: true,
                                InputProps: {
                                    disableUnderline: true,
                                    fullWidth: true,
                                    startAdornment: (
                                        <InputAdornment
                                            position="start"
                                            sx={{
                                                "&.MuiInputAdornment-root.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)":
                                                    {
                                                        margin: 0,
                                                    },
                                            }}
                                        >
                                            <CalendarIcon sx={{width: "1.1rem", margin: "0px"}} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <IconButton onClick={() => setIsOpen(!isOpen)}>
                                            {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </IconButton>
                                    ),
                                },
                                error: error,
                                helperText: helperText,
                            },
                        }}
                    />
                );
            }}
        />
    );
};
